import { NguiMapModule } from '@ngui/map';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomePageComponent } from './home-page.component';
import { SharedDirectivesModule } from '../../shared/directives/shared-directives.module';
import { SearchBarModule } from '../search-bar/search-bar.module';
import { CardPreviewComponent } from '../card-preview/card-preview.component';
import { SubNavComponent } from './sub-nav/sub-nav.component';
import { ShareBarComponent } from '../share-bar/share-bar.component';
import { GoogleMapComponent } from '../google-map/google-map.component';
import { FiltersModule } from '../filters/filters.module';
import { GalleryViewModule } from '../gallery-view/gallery-view.module';
import { ModalModule } from '../modal/modal.module';
import { NotificationPopupModalModule } from '../notification-popup-modal/notification-popup-modal.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { PanelMessageModule } from '../panel-message/panel-message.module';
import { LogoModule } from '../logo/logo.module';
import { GalleryRelatedOfficeModule } from '../gallery-view/gallery-related-office/gallery-related-office.module'
import { FooterModule } from '../footer/footer.module';
import { SharedModule } from '../../shared/shared.module';
import { SaveSearchModule } from '../save-search/save-search.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { MapModule } from '../../shared/components/map/map.module';
import { ListingCardModule } from '../../shared/components/listing-card/listing-card.module';

import { ItemSwiperModule } from '../../shared/components/item-swiper/item-swiper.module';
import { DrawerPageModule } from '../drawer/drawer-page/drawer-page.module';

@NgModule({
  imports: [
    CommonModule,
    SharedDirectivesModule,
    FiltersModule,
    SearchBarModule,
    GalleryViewModule,
    MapModule,
    NguiMapModule,
    ModalModule,
    GalleryRelatedOfficeModule,
    NotificationPopupModalModule,
    NotificationsModule,
    PanelMessageModule,
    LogoModule,
    FooterModule,
    SharedModule,
    SaveSearchModule,
    TranslateModule,
    ListingCardModule,
    SharedPipesModule,
    ItemSwiperModule,
    DrawerPageModule,
    TranslateModule.forChild()
  ],
  declarations: [
    HomePageComponent,
    SubNavComponent,
    ShareBarComponent,
    GoogleMapComponent,
    CardPreviewComponent,
    ],
  exports: [
    HomePageComponent
  ],
  providers: [
  ]
})
export class HomePageModule { }
